import React from 'react';
import Section from '../Layout/Section/Section'
import Wave from '../Dividers/wave';
import PreviewCompatibleImage from '../Utils/PreviewCompatibleImage';

import './large-editorial.scss';
import InnerContainer from '../Layout/InnerContainer/InnerContainer';

function renderBody(block, i) {
  const body = [];

  if (block.body != null) {
    body.push(
      <p key={i} className="body-copy">{block.body}</p>
    );
  }

  return body;
}

function renderImageOrVideo(image=null, video=null) {
  if (image) {
    return <PreviewCompatibleImage customClassName="cover__image" imageInfo={image} alt="cover image" />
  } else if (video) {
    return <video controls width="100%"><source src={video} type="video/mp4" /></video>
  }
}

function renderBullets(block, key) {
  const listItems = [];

  if (block.bullets) {
    block.bullets.map((item, i) => {
      return listItems.push(
        <li key={i}>{item.bullet}</li>
      )
    })
    
    return <ul className="body-copy">{listItems}</ul>;
  }
}

function renderBlocks(blocks) {
  const allBlocksHTML = [];
  
  blocks.forEach((block, i) => {
    const blockHTML = [];
    if (block.headline != null || block.body != null) {
      blockHTML.push(
        <div key={i} className="block">
          <h3 key={i} className="headline">{block.headline}</h3>
          {renderBody(block, i)}
          {renderBullets(block, i)}
        </div>
      )
    }

    allBlocksHTML.push(blockHTML);
  })


  return allBlocksHTML;
}

const LargeEditorial = ({ image, blocks, video }) => {
  return (
    <>
      <Section customClass="large-editorial">
        {renderImageOrVideo(image, video)}
        <Wave/>
      </Section>
      <Section>
        <InnerContainer customClass="copy-blocks">
          {renderBlocks(blocks)}
        </InnerContainer>
      </Section>
    </>
  )
}

export default LargeEditorial
